import React from 'react';
import { installErrorLogger } from './errorLogger';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PiBrowserBanner from './piBrowserBanner';
import { installXpertDialogs } from './xpertDialog';
import reportWebVitals from './reportWebVitals';

installXpertDialogs();

installErrorLogger();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <><App /><PiBrowserBanner /></>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/service-worker.js').catch(() => {}); });
}
